<template>
    <LayoutForm>
        <div class="sector-edit">
            <div class="form__title">
                <h1>Upload Documents</h1>
            </div>
            <DocumentForm :error-list="[]" :event_id="event_id" :id="id" />
        </div>
    </LayoutForm>
</template>

<script>
    import LayoutForm from '@layouts/LayoutForm';
    import ValidationAlert from '@components/ValidationAlert';
    import Form from '@components/Form/Form';
    import DocumentForm from '@components/Documents/Conferences/DocumentForm';

    export default {
        name: "DocumentFormPage",
        mixins: [ValidationAlert, Form],
        components: {
            DocumentForm,
            LayoutForm,
        },
        props: {
            event_id: {
                type: Number,
                required: false,
                defaults: 1,
            },
            id: {
                type: Number,
                required: false,
                defaults: 1,
            },
            errorList: {
                type: Array,
                default: () => []
            }
        },
    }
</script>

<style scoped lang="scss">

</style>
